// Public figures and their following (15 October 2026): what their screens share.
export default {
  plateforme: {
    x: 'X',
    instagram: 'Instagram',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    reddit: 'Reddit',
    presse: 'Press',
    seance: 'Parliament',
    web: 'Web',
    telegram: 'Telegram',
    site: 'Website',
  },
  sigle: { x: 'X', instagram: 'IG', facebook: 'FB', linkedin: 'IN', tiktok: 'TT', youtube: 'YT', site: 'Web' },
  sens: { favorable: 'favourable', neutre: 'neutral', defavorable: 'unfavourable' },
  position: { soutien: 'Supports', nuance: 'Nuanced', reserve: 'Reserved', oppose: 'Opposes' },
  genre: { dit: 'Their words', sur: 'What is said' },
  institution: { AN: 'National Assembly', SENAT: 'Senate', GOUVERNEMENT: 'Government', PE: 'European Parliament', AUTRES: 'Parties, regions, cities', PRESIDENCE: 'Presidency', PARTI: 'Parties', REGION: 'Regions', MAIRIE: 'Cities', ajoutees: 'Added' },
  citation: {
    guillemets: '“{texte}”',
    source: 'View source',
    releve: 'captured {quand}',
    persona: 'among “{nom}”',
    reactions: '{n} reactions',
    partages: '{n} shares',
    commentaires: '{n} comments',
    vues: '{n} views',
  },
  alerte: {
    genre: { pic: 'Spike', tonalite: 'Tone', persona: 'Persona shift', position: 'Position' },
    pic: 'Talked about {facteur} times more than usual.',
    tonaliteHausse: 'Score up to {note}, {ecart} points above the week’s average ({avant}).',
    tonaliteBaisse: 'Score down to {note}, {ecart} points below the week’s average ({avant}).',
    personaCamp: '“{persona}” switches sides: {avant} the week before, {apres} now.',
    personaPoids: '“{persona}” suddenly makes up {part}% of the conversation, against {avant}% the week before.',
    positionNouvelle: 'Takes a position on “{sujet}”: {position}.',
    positionChange: 'Changes position on “{sujet}”: {avant}, then {position}.',
  },
  suivre: 'Follow',
  suivie: 'Following',
  nePlusSuivre: 'Unfollow',
  quota: '{n} of {max} followed',
  complets: 'All {max} follows are used. Unfollow someone to free one.',
  erreur: 'Could not load.',
  fermer: 'Close',
  reessayer: 'Try again',
}
